import {
  constants,
  typographyStyles,
  mediaQueryStyles,
} from "@newsela/angelou";

const { mediaQuery } = mediaQueryStyles;
const {
  BreakpointNames: { xs, md },
} = constants.breakpoints;

const { textLObj } = typographyStyles;

const { colors } = constants;

export const rootCss = (isPreviewMode) => ({
  margin: isPreviewMode ? "16px 0 24px 0" : "24px 0",
  color: colors.ui.neutral[600],
  whiteSpace: "pre-line",
  ...textLObj,

  [mediaQuery.between(xs, md)]: {
    margin: isPreviewMode ? "16px 0 24px 0" : "32px 0 24px 0",
  },
});
